var $swiperSelector = $('.swiper-container');

$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);
    
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 180;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;

    var swiper = new Swiper(".swiper-slider-" + index, {
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      slidesPerView: 3,
       mousewheel: true,
      freeMode: true,
       navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      breakpoints: {
        1: {
           slidesPerView: 1,
		   spaceBetween: 30, 
        },
         600: {
           slidesPerView: 2,
		   spaceBetween: 30, 
        },
          875: {
           slidesPerView: 3,
		   spaceBetween: 30,
        },
       
      
       
        
        
        
        
        
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: dragSize
     }
  });
});


// toolbar reveal


(function( $ ) {
 $('.searchRevealToggle').click(function() {

$('.acToolbar').addClass( 'reveal' );

  }
);
})(jQuery);


(function( $ ) {
 $('.closeSearch ').click(function() {

$('.acToolbar').removeClass( 'reveal' );

  }
);
})(jQuery);





$(window).resize(function(){
    // If there are multiple elements with the same class, "main"
    $('.acResizeHeight').each(function() {
        $(this).height($(this).width());
    });

 
}).resize();